import MuiAlert, {AlertProps} from '@mui/material/Alert'
import MuiAlertTitle from '@mui/material/AlertTitle';

export const AlertTitle = MuiAlertTitle

export const Alert = (props: AlertProps) => {
    return <MuiAlert {...props} />
}